export const renderPlaceholderWithAsterisk = (placeholder: string) => {
  return `${placeholder} *`;
};
